
export default function Logo({ className = "", color = "#6B1F3D" }: { className?: string; color?: string }) {
  return (
    <svg 
      viewBox="0 0 200 200" 
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Outer Circle */}
      <circle 
        cx="100" 
        cy="100" 
        r="95" 
        fill="none" 
        stroke={color} 
        strokeWidth="1.5"
        opacity="0.3"
      />
      
      {/* Inner Decorative Circle */}
      <circle 
        cx="100" 
        cy="100" 
        r="85" 
        fill="none" 
        stroke={color} 
        strokeWidth="0.5"
        opacity="0.2"
      />
      
      {/* Sacred Heart Shape */}
      <path
        d="M100,140 C100,140 65,115 65,95 C65,80 75,70 85,70 C92,70 97,74 100,80 C103,74 108,70 115,70 C125,70 135,80 135,95 C135,115 100,140 100,140 Z"
        fill="none"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      
      {/* Lotus Petals - Top */}
      <path
        d="M100,50 Q95,55 95,62 Q100,58 100,50 Z"
        fill={color}
        opacity="0.6"
      />
      <path
        d="M100,50 Q105,55 105,62 Q100,58 100,50 Z"
        fill={color}
        opacity="0.6"
      />
      
      {/* Lotus Petals - Left */}
      <path
        d="M55,85 Q60,82 67,85 Q62,88 55,85 Z"
        fill={color}
        opacity="0.5"
      />
      
      {/* Lotus Petals - Right */}
      <path
        d="M145,85 Q140,82 133,85 Q138,88 145,85 Z"
        fill={color}
        opacity="0.5"
      />
      
      {/* Sacred Geometry - Small Dots */}
      <circle cx="100" cy="65" r="2" fill={color} opacity="0.4" />
      <circle cx="75" cy="90" r="1.5" fill={color} opacity="0.3" />
      <circle cx="125" cy="90" r="1.5" fill={color} opacity="0.3" />
      
      {/* Crescent Moon */}
      <path
        d="M100,145 Q95,150 90,145 Q95,148 100,145 Z"
        fill={color}
        opacity="0.4"
      />
      
      {/* Sparkle Elements */}
      <path
        d="M70,60 L71,62 L73,61 L71,63 L72,65 L70,64 L68,65 L69,63 L67,61 L69,62 Z"
        fill={color}
        opacity="0.5"
      />
      <path
        d="M130,60 L131,62 L133,61 L131,63 L132,65 L130,64 L128,65 L129,63 L127,61 L129,62 Z"
        fill={color}
        opacity="0.5"
      />
    </svg>
  );
}
